<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col class="py-0">
        <InspResultReportForm :inspIndexNo="inspIndexNo" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import InspResultReportForm from '@/components/organisms/report/print/InspResultReportForm'
import { StringUtils } from '@/plugins/string'

export default {
  name: 'InspResultReportPage',

  mixins: [APIUtils, Message, Loading],

  components: {
    InspResultReportForm,
  },

  data() {
    return {
      inspIndexNo: '',
    }
  },

  async created() {
    const query = this.$route.query
    if (query.inspIndexNo) {
      try {
        this.startLoading()
        if (!StringUtils.isHalfWidth(query.inspIndexNo)) {
          // REST-APIのURLパラメータで使用できない値を受け付けないようにチェック
          this.setErrorMessage(this.$t('MSG0049', { p0: query.inspIndexNo }))
          return
        }
        const params = {
          userCompanyCd: this.$store.getters.companyCd,
        }
        const element = await API.get(`/inspIndex/inspIndexes/${query.inspIndexNo}`, params)
        this.inspIndexNo = element.inspIndexNo
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0002') })))
      } finally {
        this.stopLoading()
      }
    }
  },
}
</script>
